import { Packet } from "../Interfaces/commonDtos";
import { IAddInstrumentResponse } from "../Interfaces/insSettingsInterfaces";
import { deleteRequest, postRequest } from "./requestTemplates";

export const addInstrument = (
  url: string
): Promise<Packet<IAddInstrumentResponse>> =>
  postRequest("/v1/step/addInstrument", { url });

export const deleteInstrument = (
  url: string
): Promise<Packet<IAddInstrumentResponse>> =>
  deleteRequest("/v1/step/deleteInstrument", { url });

export const addBulkInstrument = (
  excelFile: FormData
): Promise<Packet<IAddInstrumentResponse>> =>
  postRequest("/v1/step/addBulkInstrument", excelFile);

export const deleteBulkInstrument = (
  excelFile: FormData
): Promise<Packet<IAddInstrumentResponse>> =>
  deleteRequest("/v1/step/deleteBulkInstrument", excelFile);
